import React, { forwardRef, useContext } from 'react';
import styled, { css, ThemeContext } from 'styled-components';
import PropTypes from 'prop-types';
import withCssProps from '../../hocs/withCssProps';
import { IavatarHome, IavatarUser } from '../AgroIcon/icons';
var icons = {
  user: IavatarUser,
  home: IavatarHome
};
var sizes = {
  md: {
    avatar: '32px',
    icon: '24px'
  }
};
var AgroAvatar = withCssProps( /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$src = _ref.src,
    src = _ref$src === void 0 ? null : _ref$src,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? 'agro-avatar' : _ref$alt,
    _ref$href = _ref.href,
    href = _ref$href === void 0 ? null : _ref$href,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? null : _ref$className,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? '_self' : _ref$target,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? 'user' : _ref$icon,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size;
  var theme = useContext(ThemeContext);
  var Icon = icons[icon];
  var getAvatar = function getAvatar() {
    return /*#__PURE__*/React.createElement(Avatar, {
      className: className,
      size: size
    }, src ? /*#__PURE__*/React.createElement(Img, {
      src: src,
      alt: alt
    }) : /*#__PURE__*/React.createElement(Icon, {
      width: sizes[size].icon,
      height: sizes[size].icon,
      fill: theme.colors.gray200
    }));
  };
  return href ? /*#__PURE__*/React.createElement(Link, {
    href: href,
    target: target,
    ref: ref
  }, getAvatar()) : getAvatar();
}));
AgroAvatar.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  href: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.oneOf(['user', 'home']),
  size: PropTypes.oneOf(['md']),
  target: PropTypes.oneOf(['_self', '_blank', '_parent', '_top'])
};
AgroAvatar.displayName = 'AgroAvatar';
export { AgroAvatar };
var Link = styled.a.withConfig({
  displayName: "AgroAvatar__Link",
  componentId: "sc-12felwz-0"
})(["all:unset;cursor:pointer;"]);
var Avatar = styled.div.withConfig({
  displayName: "AgroAvatar__Avatar",
  componentId: "sc-12felwz-1"
})(["", " border:1px solid ", ";box-shadow:0px 1px 2px rgba(0,0,0,0.1);border-radius:50%;justify-content:center;display:flex;align-items:center;"], function (_ref2) {
  var size = _ref2.size;
  return css(["width:", ";height:", ";"], sizes[size].avatar, sizes[size].avatar);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.gray400;
});
var Img = styled.img.withConfig({
  displayName: "AgroAvatar__Img",
  componentId: "sc-12felwz-2"
})(["display:inline-block;-o-object-fit:scale-down;object-fit:scale-down;width:100%;height:100%;border-radius:50%;"]);